import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { AdvisorEngineContactSyncSettings } from './AdvisorEngineContactSyncSettings'

export const AdvisorEngineSpecificSettings = (): ClickNavigationProps[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <AdvisorEngineContactSyncSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.ADVISOR_ENGINE} /> },
  ]
}
